import algoliasearch, { SearchClient } from 'algoliasearch';

export default function getAlgoliaClientDefault(): SearchClient {
  return algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
    process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
  );
}
